import api from './api';

export const herdTagService = {
  getDashboard: async (farmId) => {
    const response = await api.get(`/farms/${farmId}/herd-tags/dashboard`);
    return response.data;
  },

  list: async (farmId, params = {}) => {
    const response = await api.get(`/farms/${farmId}/herd-tags`, { params });
    return response.data;
  },

  createCustom: async (farmId, name, description) => {
    const response = await api.post(`/farms/${farmId}/herd-tags`, {
      name,
      description,
      membership: 'manual',
    });
    return response.data;
  },

  createSmart: async (farmId, payload) => {
    const response = await api.post(`/farms/${farmId}/herd-tags`, {
      ...payload,
      membership: 'smart',
    });
    return response.data;
  },

  updateSmart: async (farmId, tagId, payload) => {
    const response = await api.patch(`/farms/${farmId}/herd-tags/${tagId}`, payload);
    return response.data;
  },

  getSmartRuleCatalog: async (farmId) => {
    const response = await api.get(`/farms/${farmId}/herd-tags/smart-rule-catalog`);
    return response.data;
  },

  previewSmartRules: async (farmId, rules, options = {}) => {
    // A preview is only useful now, so never queue it offline
    const response = await api.post(
      `/farms/${farmId}/herd-tags/preview-rules`,
      {
        rules,
        limit: options.limit ?? 100,
        context: options.context ?? 'smart',
      },
      { __skipOfflineQueue: true },
    );
    return response.data;
  },

  getPerformanceRuleCatalog: async (farmId) => {
    const response = await api.get(`/farms/${farmId}/herd-tags/performance-rule-catalog`);
    return response.data;
  },

  getPerformanceOverview: async (farmId) => {
    const response = await api.get(`/farms/${farmId}/herd-tags/performance-overview`);
    return response.data;
  },

  createPerformance: async (farmId, payload) => {
    const response = await api.post(`/farms/${farmId}/herd-tags`, {
      ...payload,
      membership: 'performance',
    });
    return response.data;
  },

  updatePerformance: async (farmId, tagId, payload) => {
    const response = await api.patch(`/farms/${farmId}/herd-tags/${tagId}`, payload);
    return response.data;
  },

  deleteCustom: async (farmId, tagId) => {
    const response = await api.delete(`/farms/${farmId}/herd-tags/${tagId}`);
    return response.data;
  },

  recompute: async (farmId) => {
    // A refresh is only useful now, so never queue it offline
    const response = await api.post(`/farms/${farmId}/herd-tags/recompute`, null, { __skipOfflineQueue: true });
    return response.data;
  },

  addMembers: async (farmId, tagId, animalIds) => {
    const response = await api.post(`/farms/${farmId}/herd-tags/${tagId}/members`, {
      animal_ids: animalIds,
    });
    return response.data;
  },

  /** Saves a manual tag's list in one request. */
  syncMembers: async (farmId, tagId, addIds, removeIds) => {
    const response = await api.put(`/farms/${farmId}/herd-tags/${tagId}/members`, {
      add_ids: addIds,
      remove_ids: removeIds,
    });
    return response.data;
  },

  removeMember: async (farmId, tagId, animalId) => {
    const response = await api.delete(`/farms/${farmId}/herd-tags/${tagId}/members/${animalId}`);
    return response.data;
  },

  freezeCohort: async (farmId, tagId) => {
    const response = await api.post(`/farms/${farmId}/herd-tags/${tagId}/freeze`);
    return response.data;
  },

  /** Shared species lifecycle names and age bands (same source as system tag rules). */
  getSpeciesLifecycleConfig: async () => {
    const response = await api.get('/species-lifecycle-config');
    return response.data;
  },
};

export default herdTagService;
